// extracted by mini-css-extract-plugin
export default {"box":"Box_box__a2vMO","gradient":"Box_gradient__FCd3Q","header":"Box_header__geVhu"};